import { render } from "./SplitTypeSelector.vue?vue&type=template&id=67f5d0b8&bindings={\"customSeparator\":\"data\",\"splitOptions\":\"data\",\"splitType\":\"options\",\"separatorChanged\":\"options\"}"
import script from "./SplitTypeSelector.vue?vue&type=script&lang=js"
export * from "./SplitTypeSelector.vue?vue&type=script&lang=js"
script.render = render

export default script
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QInput});
